import { render, staticRenderFns } from "./certificate_login.vue?vue&type=template&id=fc3e2e66&scoped=true"
import script from "./certificate_login.vue?vue&type=script&lang=js"
export * from "./certificate_login.vue?vue&type=script&lang=js"
import style0 from "./certificate_login.vue?vue&type=style&index=0&id=fc3e2e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3e2e66",
  null
  
)

export default component.exports